// extracted by mini-css-extract-plugin
export default {"authenticationContainer":"Authentification_authenticationContainer__MR1oS"};